import { Injectable, Inject } from '@angular/core';
import { ENV_CONFIG } from 'src/app/core/injection.token';
import { ApiService } from 'src/app/core/services/api.service';
import { FAQEvents } from './events';

@Injectable()
export class FrequentlyAskedQuestionsAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'faq';

  public getFilteredFrequentlyAskedQuestions(questionFilter: string = '') {
    const request = 'getFilteredFrequentlyAskedQuestions';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.DynamicResponse<app.models.FAQModel[]>>(url, {
      questionFilter: questionFilter,
    });
  }

  public getFrequentlyAskedQuestionById(frequentlyAskedQuestionId: string) {
    const request = 'getFrequentlyAskedQuestionById';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.DynamicResponse<app.models.FAQModel>>(url, {
      frequentlyAskedQuestionId: frequentlyAskedQuestionId,
    });
  }

  public saveFrequentlyAskedQuestion(requestBody: app.models.FAQModel) {
    const request = 'saveFrequentlyAskedQuestion';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    const body = requestBody;

    return this._apiService.postAsync<app.models.ServerResponseModel>(url, body, [
      FAQEvents.FrequentlyAskedQuestionSaved,
    ]);
  }

  public deleteFrequentlyAskedQuestion(requestBody: string) {
    const request = 'deleteFrequentlyAskedQuestion';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    const body = { frequentlyAskedQuestionId: requestBody };

    return this._apiService.postAsync<app.models.ServerResponseModel>(url, body, [
      FAQEvents.FrequentlyAskedQuestionDeleted,
    ]);
  }

  public saveFrequentlyAskedQuestionsOrder(requestBody: app.models.FAQModel[]) {
    const request = 'saveFrequentlyAskedQuestionsOrder';
    const jsonObject: { [key: string]: number } = {};
    requestBody.forEach(x => {
      jsonObject[x.frequentlyAskedQuestionId] = requestBody.indexOf(x) + 1;
    });
    const body = { frequentlyAskedQuestionsSaveOrderDictionary: jsonObject };
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    return this._apiService.postAsync<app.models.ServerResponseModel>(url, body, [
      FAQEvents.FrequentlyAskedQuestionsOrdersSaved,
    ]);
  }
}
